exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#received-files-sidebar[data-v-4ddd7ace]{min-width:250px;border-right:1px solid #e9ecef;z-index:6}.bg-light-dark[data-v-4ddd7ace]{background-color:#dee2e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ddd7ace","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/received-files-view/received-files-sidebar.vue
// module id = 93
// module chunks = 0